import axios from 'axios';

export type ApiError = {
  message: string | undefined;
  status: number;
};

export const isApiError = (error: any): error is ApiError => error && error.status;

export const axiosInstance = axios.create();
// Add a response interceptor
axiosInstance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Set error message to 'Something went wrong' instead of 'Internal server error'
    const errMsg = !error.response || error.response.status >= 500 ? 'Something went wrong' : error.response.data.error;
    return Promise.reject({ message: errMsg, status: error.response.status } as ApiError);
  },
);
